import React, { FC, useEffect, useRef } from 'react';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import OperatorPanelButton from '@components/operatorPanel/components/elements/buttons/OperatorPanelButton';
import LoadableActionButton, { LoadableActionButtonHandle } from '@components/operatorPanel/components/elements/buttons/LoadableActionButton';
import { PanelProps } from '@components/operatorPanel/components/panel';

export interface SelectNCFileTypeButtonProps extends Pick<PanelProps, 'CC' | 'scale' | 'font'> {
  onPress: (onActionStart: () => void) => void;
  autoTrigger?: boolean;
}

const SelectNCFileTypeButton: FC<SelectNCFileTypeButtonProps> = ({
  onPress,
  CC,
  scale = initialScale,
  font = initialFont,
  autoTrigger = false,
}) => {
  const ref = useRef<LoadableActionButtonHandle>(null);
  const hasAutoTriggeredRef = useRef(false);

  useEffect(() => {
    if (autoTrigger && !hasAutoTriggeredRef.current) {
      hasAutoTriggeredRef.current = true;
      ref.current?.trigger();
    }
  }, [autoTrigger]);

  return (
    <LoadableActionButton ref={ref} onPress={onPress} CC={CC} scale={scale}>
      {(handlePress) => (
        <OperatorPanelButton
          onPress={handlePress}
          CC={CC}
          testID={TEST_IDS.operatorPanel.home.selectNCFileTypeButton}
          text="Select NC File Type"
          iconsConfig={[
            { icon: 'linked', width: scale(20), height: scale(21) },
            { icon: 'change', width: scale(20), height: scale(21), color: CC('Status/Light/Change') },
            { icon: 'crossedBell', width: scale(20), height: scale(17), color: CC('Status/Light/Not Productive') },
            { icon: 'setup', width: scale(20), height: scale(21), color: CC('Status/Light/Setup') },
          ]}
          textFont="Headline Large Bold"
          textColor="Label/Light/AlwaysDark Primary"
          customButtonBgColor="Label/Light/AlwaysLight Primary"
          buttonContainerStyle={{
            width: scale(336),
            height: scale(120),
            paddingTop: scale(29.5),
            paddingBottom: scale(32.5),
            paddingHorizontal: scale(15),
            gap: scale(12),
            borderRadius: scale(18),
          }}
          iconContainerStyle={{
            marginTop: scale(2),
            marginBottom: scale(2),
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: scale(25),
          }}
          scale={scale}
          font={font}
        />
      )}
    </LoadableActionButton>
  );
};

export default SelectNCFileTypeButton;
